/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { WearablesStrictHttpResponse } from '../../wearables-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeviceConnectionExcelRequestModel } from '../../models/device-connection-excel-request-model';
import { ReportResultModel } from '../../models/report-result-model';

export interface ReportDeviceConnectionExcelPost$Params {
  
    /**
     * Request with FromDate and ToDate (inclusive).
     */
    body?: DeviceConnectionExcelRequestModel
}

export function reportDeviceConnectionExcelPost(http: HttpClient, rootUrl: string, params?: ReportDeviceConnectionExcelPost$Params, context?: HttpContext): Observable<WearablesStrictHttpResponse<ReportResultModel>> {
  const rb = new RequestBuilder(rootUrl, reportDeviceConnectionExcelPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as WearablesStrictHttpResponse<ReportResultModel>;
    })
  );
}

reportDeviceConnectionExcelPost.PATH = '/Report/DeviceConnectionExcel';
